import React, { useEffect, useState } from 'react'
import CustomTime from 'designer/component/element/Time'
import objectPath from 'object-path'
import moment from 'moment'

const TimeControl = (props) => {
  const { uischema, handleChange, path, config } = props
  const data = config?.jsonData
  let { defaultValue, defaultType } = uischema

  const [initial, setInitial] = useState(null)

  const updateData = (time) => {
    let value = null
    if (time?.format) {
      value = moment(time.format).format('HH:mm:ss')
    }
    updateValue(value)
  }

  const updateValue = async (value) => {
    handleChange(path, value)
  }

  useEffect(() => {
    if (initial) return
    if (!data && defaultType === 'current') {
      defaultValue = moment().format('HH:mm:ss')
      updateValue(defaultValue)
      setInitial(true)
    }
  }, [data])

  return (
    <CustomTime
      {...props}
      uischema={uischema}
      time={data}
      updateData={updateData}
    />
  )
}

export default TimeControl
